import styled from '@emotion/styled'
import { Item, Props as ItemProps } from 'app/components/Intro/One/Item'
import { FlexBox } from 'app/components/Layout/FlexBox'
import { styles } from 'app/theme'
import { Media } from 'app/theme/media'
import { motion, useScroll, useTransform } from 'framer-motion'
import React, { memo } from 'react'

export interface Props {
  medias?: ItemProps[]
  title?: string
}

export const SlidingText = memo(function SlidingText({ medias, title }: Props) {
  if (!title) {
    return null
  }

  const { scrollYProgress } = useScroll()
  const x = useTransform(scrollYProgress, [0, 1], ['25%', '-40%'])

  return (
    <Media greaterThanOrEqual="desktopSmall">
      {(className: any, renderChildren: any) => {
        return renderChildren ? (
          <Container className={className}>
            <Wrapper style={{ x }}>
              {Array.from({ length: 4 }).map((_item, index) => (
                <Title key={index}>{title}</Title>
              ))}
            </Wrapper>

            {medias ? (
              <Items dial={8} row space="between">
                {medias.map((item, index) => (
                  <Item
                    key={index}
                    index={index}
                    isOdd={index % 2 ? true : false}
                    isVisible={true}
                    {...item}
                  />
                ))}
              </Items>
            ) : null}
          </Container>
        ) : null
      }}
    </Media>
  )
})

const Container = styled.section`
  margin-top: 9.75rem;
  overflow: hidden;
`

const Wrapper = styled(motion.div)``

const Title = styled.span`
  ${styles.title.large}

  margin: 0 1.875rem;
  white-space: nowrap;
`

const Items = styled(FlexBox)`
  margin-top: 5.25rem;

  > div,
  > video {
    aspect-ratio: 0.75;
    &.odd {
      width: 23.333vw;
    }
  }
`
